// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3-VfS","right":"styles_right__2jfYY"};